import { useCurrentRole } from 'hooks/slices';
import { useIsAdminImpersonating, useTrueUserId } from 'hooks/slices/useCurrentUser';
import { useMemo } from 'react';
import { getOrganizationRoleResourceTypeKey } from './trackingUtils';

export const useTrackingContext = () => {
  const role = useCurrentRole();
  const trueUserId = useTrueUserId();
  const isAdminImpersonating = useIsAdminImpersonating();

  return useMemo(
    () => ({
      ...(role && {
        [getOrganizationRoleResourceTypeKey(role.resource_type)]: role.resource_id,
        role: role.kind,
      }),
      ...(isAdminImpersonating && trueUserId && { impersonatingUserId: trueUserId }),
      device: 'desktop' as const,
    }),
    [role, isAdminImpersonating, trueUserId]
  );
};
